




<div class="container-fluid p-0 d-lg-block">
    <footer class="bg-white border-top d-md-flex d-none flex-wrap gap-3 justify-content-center px-5 py-5 row text-center">

        <div class="col-md-3 col-lg-2 p-0" *ngFor="let cat of categories">

          <ul class="list-unstyled flex-column text-s-1 footer-menu" #footer_menu>

            <h5
            class="text-s-2 fw-bold cursor-pointer"
            (click)="redirectToProductcategoryByCAT(cat.id)"
            >
              {{ cat?.name }}
            </h5>

            <li class="nav-item mb-2" *ngFor="let sub_cat of cat.sub_categories">
              <a
              class="nav-link p-0 text-muted"
              (click)="redirectToProductcategoryBySubCAT(sub_cat.id)"
              >
                {{ sub_cat?.name }}
              </a>
            </li>

          </ul>

          <div *ngIf="cat.sub_categories.length > 5">

            <!-- if -->
            <div #show_btn class="">
              <h2 class="fs-6 cursor-pointer" (click)="toggle_footer_menu(footer_menu, true, show_btn, hide_btn);">
                {{ "section_show" | translate: "footer" }}
              </h2>
            </div>
  
            <!-- else -->
            <div #hide_btn class="hide_btn">
              <h2 class="fs-6 cursor-pointer" (click)="toggle_footer_menu(footer_menu, false, show_btn, hide_btn);">
                {{ "section_hide" | translate: "footer" }}
              </h2>
            </div>
          
          </div>

        </div>

    </footer>
</div>
